import type { PropsWithChildren, FC } from 'react'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { NavLink } from '../NavLink'
import { useAbsoluteRouteMatch } from '../../../../../utils/routing/useAbsoluteRouteMatch.hooks'
import { NavItemStyle, TextContainer } from '../NavItem'
import { type AccessControlConfig } from '../../../../../legacy/components/AccessControl/accessControl.utils'
import useAccessControl from '../../../../../legacy/components/AccessControl/useAccessControl'
import ButtonBase from '../../../../../legacy/components/ButtonBase'

type Props = {
  onClick: () => void
  route?: string
  title: string
  accessControl?: AccessControlConfig
  position?: number
}

export const NavLinkNoRoute = styled(ButtonBase)(() => ({
  all: 'unset',
  cursor: 'pointer',
  width: '100%',
}))

export const Option: FC<PropsWithChildren<Props>> = ({ title, onClick, route, accessControl }) => {
  const intl = useIntl()
  const routeParams = useAbsoluteRouteMatch()
  const hasAccess = useAccessControl()

  const selected = route === routeParams?.route

  if (accessControl && !hasAccess(accessControl)) {
    return null
  }

  // If there's no route, render a button to avoid navigation and preserve URL params
  if (!route) {
    return (
      <NavLinkNoRoute onClick={onClick}>
        <NavItemStyle selected={selected} padding="8px 24px">
          <TextContainer>{intl.formatMessage({ id: title })}</TextContainer>
        </NavItemStyle>
      </NavLinkNoRoute>
    )
  }

  return (
    <NavLink onClick={onClick} route={route}>
      <NavItemStyle selected={selected} padding="8px 24px">
        <TextContainer>{intl.formatMessage({ id: title })}</TextContainer>
      </NavItemStyle>
    </NavLink>
  )
}
